export interface HmlDownloadDocModel {
  id: number
  title: string
  thumbnail: string
}

export interface HmlDownloadDocDetailModel extends HmlDownloadDocModel {
  contents: string
  attachments: HmlDocFileModel[]
  previews: HmlDocFileModel[]
}

export interface HmlDocFileModel {
  docFileId: number
  url: string
  fileNm: string
  sortSeq: number
}

export default () => {
  const { locale } = useI18n()

  function fetchDownloadDocs() {
    return useAPI<HmlDownloadDocModel[]>('/hml/v1/downloads', {
      query: {
        languageGbSn: locale.value,
      },
    })
  }

  function fetchDownloadDocDetail(id: number) {
    return useAPI<HmlDownloadDocDetailModel>(`/hml/v1/downloads/${id}`, {
      query: {
        languageGbSn: locale.value,
      },
    })
  }

  return {
    fetchDownloadDocs,
    fetchDownloadDocDetail,
  }
}
